import { Timestamp, getDocs, query, where } from "@firebase/firestore";
import { ReactionsRef, storage } from "../../../../firebase";
import moment from "moment";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { v4 as uuidv4 } from "uuid";

import {
  getSingleQuickTale,
  getSingleUser,
} from "../../../../modules/OrganizationQuickTales/hooks/QuickTalesHooks";
import { getMostRecentUserContentReport } from "../../GAContentModeration/hooks/ContentReportsHooks";

export const getAllGAReactions = async () => {
  try {
    const response = await getDocs(ReactionsRef);
    return response;
  } catch (error) {
    console.log("Error fetching data from Firestore:", error.message);
    // console.error("Error fetching data from Firestore:", error.message);
    return [];
  }
};

export const getFilterReactions = async (
  statusFilterOptions,
  creationDateRange,
  reportedStatusOptions,
  setLoading,
  handleFilterModalClose
) => {
  setLoading(true);

  // Function to deduplicate documents based on their IDs
  const deduplicate = (arr) => {
    const uniqueIds = new Set();
    const uniqueDocs = [];
    arr.forEach((doc) => {
      if (!uniqueIds.has(doc.id)) {
        uniqueIds.add(doc.id);
        uniqueDocs.push(doc);
      }
    });
    return uniqueDocs;
  };

  try {
    let results = [];

    const statusOptions =
      statusFilterOptions.length > 0 ? statusFilterOptions : [null];
    const reportedStatusOptionsArray =
      reportedStatusOptions.length > 0 ? reportedStatusOptions : [null];

    for (const status of statusOptions) {
      for (const reportedStatus of reportedStatusOptionsArray) {
        let queries = [];

        if (status !== null) {
          queries.push(where("status", "==", status));
        }

        if (reportedStatus !== null) {
          queries.push(where("reportedStatus", "==", reportedStatus));
        }

        if (
          creationDateRange &&
          creationDateRange.startDate &&
          creationDateRange.endDate
        ) {
          queries.push(where("createdAt", ">=", creationDateRange.startDate));
          queries.push(where("createdAt", "<=", creationDateRange.endDate));
        }

        if (queries.length > 0) {
          const q = query(ReactionsRef, ...queries);
          const querySnapshot = await getDocs(q);
          console.log("results:", querySnapshot.docs[0]?.data());

          const fetchDetailsPromises = querySnapshot.docs.map(async (doc) => {
            const quicktaleSnapshot = await getSingleQuickTale(
              doc?.data()?.quicktale
            );
            const quicktaleData = quicktaleSnapshot?.exists()
              ? quicktaleSnapshot.data()
              : {};

            const qtCreatedUserSnapshot = await getSingleUser(
              quicktaleData?.createdBy
            );
            const qtCreatedUserData = qtCreatedUserSnapshot?.exists()
              ? qtCreatedUserSnapshot.data()
              : {};

            const userSnapshot = await getSingleUser(doc?.data()?.user);
            const userData = userSnapshot?.exists() ? userSnapshot.data() : {};
            let reactionReportsTemp = await getMostRecentUserContentReport(
              doc.id
            );
            // console.log(reactionReportsTemp);
            let statusTemp = "";

            // Extract the status from the report, if it exists
            reactionReportsTemp.forEach((doc) => {
              // console.log("report::", doc);
              statusTemp = doc?.status?.status;
            });

            return {
              id: doc.id,
              ...doc.data(),
              quicktaleData,
              userData,
              qtCreatedByData: qtCreatedUserData,
              reportedStatus: statusTemp,
            };
          });

          // Wait for all fetches to complete
          const queryResults = await Promise.all(fetchDetailsPromises);
          results = results.concat(queryResults);
        }
      }
    }

    // Deduplicate the results before returning
    const uniqueResults = deduplicate(results);
    handleFilterModalClose(); // Assuming it's appropriate to close the modal here
    return uniqueResults;
  } catch (error) {
    console.error("Error filtering Reactions:", error);
    return []; // Return an empty array in case of error
  } finally {
    setLoading(false);
  }
};

// export const getFilterReactions = async (
//   statusFilterOptions,
//   // creationDateFilterOptions,
//   creationDateRange,
//   reportedStatusOptions,
//   setLoading,
//   handleFilterModalClose
// ) => {
//   setLoading(true);

//   // Function to deduplicate documents based on their IDs
//   const deduplicate = (arr) => {
//     const uniqueIds = new Set();
//     const uniqueDocs = [];
//     arr.forEach((doc) => {
//       if (!uniqueIds.has(doc.id)) {
//         uniqueIds.add(doc.id);
//         uniqueDocs.push(doc);
//       }
//     });
//     return uniqueDocs;
//   };

//   try {
//     // Construct the initial query with "Who Can Listen" and "QT Status" filters
//     let queries = [
//       ...statusFilterOptions.map((option) => where("status", "==", option)),
//       ...reportedStatusOptions.map((option) =>
//         where("reportedStatus", "==", option)
//       ),
//     ];

//     // Add date range filter if provided
//     if (
//       creationDateRange &&
//       creationDateRange.startDate &&
//       creationDateRange.endDate
//     ) {
//       queries.push(where("createdAt", ">=", creationDateRange.startDate));
//       queries.push(where("createdAt", "<=", creationDateRange.endDate));
//     }

//     // Execute the query
//     const q = query(ReactionsRef, ...queries);
//     const querySnapshot = await getDocs(q);
//     console.log("results:", querySnapshot.docs[0].data());

//     const fetchDetailsPromises = querySnapshot.docs.map(async (doc) => {
//       const quicktaleSnapshot = await getSingleQuickTale(
//         doc?.data()?.quicktale
//       );
//       const quicktaleData = quicktaleSnapshot?.exists()
//         ? quicktaleSnapshot.data()
//         : {};

//       const qtCreatedUserSnapshot = await getSingleUser(
//         quicktaleData?.createdBy
//       );
//       const qtCreatedUserData = qtCreatedUserSnapshot?.exists()
//         ? qtCreatedUserSnapshot.data()
//         : {};

//       const userSnapshot = await getSingleUser(doc?.data()?.user);
//       const userData = userSnapshot?.exists() ? userSnapshot.data() : {};

//       return {
//         id: doc.id,
//         ...doc.data(),
//         quicktaleData,
//         userData,
//         qtCreatedByData: qtCreatedUserData,
//       };
//     });

//     // Wait for all fetches to complete
//     const results = await Promise.all(fetchDetailsPromises);

//     console.log("filtered data:", results);

//     // Deduplicate the results before returning
//     const uniqueResults = deduplicate(results);
//     handleFilterModalClose(); // Assuming it's appropriate to close the modal here
//     return uniqueResults;
//   } catch (error) {
//     console.error("Error filtering QuickTales:", error);
//     return []; // Return an empty array in case of error
//   } finally {
//     setLoading(false);
//   }
// };

export const uploadReactionAudioToStorage = async (file) => {
  const newFilename = uuidv4();
  const storageRef = ref(storage, `quicktalesReactions/audio/${newFilename}`);
  await uploadBytes(storageRef, file);
  return await getDownloadURL(storageRef);
};
